import { Injectable } from '@angular/core';
import {
  ProductService,
  GungFlowService,
  Product,
  GungBase,
  AuthService,
  SelectedCustomerService
} from 'gung-standard';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, first, tap } from 'rxjs';
import { RefSystemSettingsService } from '../ref-system-settings.service';

@Injectable({
  providedIn: 'root'
})
export class RefProductService extends ProductService {
  constructor(
    http: HttpClient,
    private translate: TranslateService,
    gungFlowService: GungFlowService,
    authService: AuthService,
    private refSystemSettingsService: RefSystemSettingsService,
    selectedCustomerService: SelectedCustomerService
  ) {
    super();
  }

  protected productMap(productToMap: Product): Product {
    productToMap = super.productMap(productToMap);
    const code = productToMap.extra.ar.itemtypecd2;

    if (this.refSystemSettingsService.colorMap[code + '']) {
      productToMap.extra.hexBorderColor = this.refSystemSettingsService.colorMap[code + ''];
    } else {
      productToMap.extra.hexBorderColor = '#000000';
    }
    return productToMap;
  }
}
